<template>
  <div>
    <div class="top">
      <TopContent />
    </div>
    <div class="product_bg"></div>
    <div class="product_con">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item><span @click="() => { this.$router.go(-1) }" class="goback">返回</span></el-breadcrumb-item>
        <el-breadcrumb-item>医疗精准扶贫</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="con_tit fontsize2">医疗精准扶贫</div>
      <p class="fontsize1">
        <span class="con_text">简介：</span><br>
        医疗精准扶贫远程医疗网络门诊，提供一种远程指导基层医生看诊的操作工具操作流程规范，
        为村民、村卫生室、远程专家建立一个看诊流程闭环。简单来说就是：
        村民能够通过手机方便查询自己的看诊详情（即病历本的电子化文档）、
        村民通过手机申请看诊、村民通过手机上传自己已经有的病情资料（各种检查单据等）；
        村卫生室通过电脑平台完成看诊流程，远程专家通过视频通话工具远程指导看诊及给出看诊指导意见。<br><br>
        <span class="con_text">特点/技术指标：</span>
        <br>
        通过互联网建立医疗专家和 病人之间的即时医疗互动，学校对 口扶贫乡村村民在村卫生室即可向学校和省级专家咨询看诊。<br><br>
        <span class="con_text">主要功能：</span>
        <br>
        ·可通过手持设备拍摄各类检查单据并上传系统 <br>
        ·记录下级医生向专家求助的内容 <br>
        ·记录上级专家给出的指导意见 <br>
        ·查看下级医生上传的病历资料 <br>
        ·基层医生可根据专家的治疗指导意见，最终给出患者治疗方案 <br>
        ·支持与医院系统进行接口数据传输，包括：HIS、LIS、PACS 等系统<br>
      </p>
      <div class="con_img"><img src="../../assets/img/Product6s.png" /></div>
    </div>
    <div class="bottom">
      <BottomContent />
    </div>
  </div>
</template>
<script>
import TopContent from "@/components/Top/index.vue";
import BottomContent from "@/components/Bottom/index.vue";
export default {
  components: { TopContent, BottomContent },
  data () {
    return {

    }
  },
  mounted () {
    if (document && document.body) {
      document.body.style.margin = '0px';
      this.originalBodyMargin = document.body.style.margin;
    }
  },
  beforeDestroy () {
    if (document && document.body) {
      document.body.style.margin = this.originalBodyMargin || '';
    }
  }
}
</script>
<style lang="scss" src="../../assets/css/PC.scss" scoped></style>
<style lang="scss" scoped>
.goback:hover {
  cursor: pointer;
  color: #409EFF;
}

.bottom {
  height: 70px;
}

.product_bg {
  background-image: url("../../assets/img/Product_bg.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 70vh;
}

.fontsize1 {
  font-size: 19px;
}

.fontsize2 {
  font-size: 24px;
}

.product_con {
  width: 70%;
  margin: 0px auto 50px auto;
  padding: 20px;

  .con_tit {
    font-weight: 600;
    text-align: center;
    margin: 20px 0px;
  }

  .con_text {
    font-weight: 600;
  }

  .con_img {
    display: flex;
    justify-content: center;

    img {
      max-width: 80%;
      height: 100%;
    }

  }
}

@media (max-width: 1439px) and (min-width: 10px) {
  .product_bg {
    height: 30vh;
  }

  .fontsize1 {
    font-size: 15px;
  }

  .product_con {
    margin: auto;
    width: 90%;

    .con_img {
      img {
        max-width: 90%;
      }
    }
  }
}
</style>